var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFontSizeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.62891 14.646H4.33204L3.42579 17H2L5.27345 9.00667H6.6172L10.1016 17H8.59376L7.62891 14.646ZM4.73829 13.5827H7.19923L6.39454 11.5843C6.2311 11.1847 6.07868 10.7813 5.93751 10.3743C5.84349 10.7411 5.7261 11.1023 5.58595 11.456L4.73829 13.5827ZM18.3789 13.8283H14.1563L12.9375 16.9817H10.7305L15.2227 6H17.2148L22 16.9817H19.6758L18.3789 13.8283ZM16.2305 8.431C16.125 8.783 16.0039 9.12767 15.8672 9.46867L14.8008 12.1417H17.6992L16.6914 9.63733C16.5295 9.23759 16.3785 8.83543 16.2305 8.431Z",
    fill: "#454551"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFontSizeIcon);
export default __webpack_public_path__ + "static/media/fontSizeIcon.6d7f799ac443e821e143a652c2b46cdd.svg";
export { ForwardRef as ReactComponent };